import { useUserProfile } from 'hooks/useIdentifyAnalytics/helpers';
import { getCookie } from 'cookies-next';
import { RIVT_TOKEN_COOKIE_NAME } from 'lib/middleware/constants';
import { ExtendedRawUserProfile } from 'hooks/useIdentifyAnalytics/types';
import { useAmplitudeFlags } from 'helpers/hooks/useAmplitudeFlags';
import { FEATURE_FLAGS } from 'lib/amplitude/constants';

import { getHeaderUserData, getFooterUserData } from './getUserData';
import {
  legacyGetHeaderUserData,
  legacyGetFooterUserData
} from './legacyGetUserData';

export const useOutsidePackagesUserData = (
  placeholderData?: ExtendedRawUserProfile
) => {
  const rivtToken = getCookie(RIVT_TOKEN_COOKIE_NAME);
  const { data: RIVTProfile, isFetching } = useUserProfile(
    rivtToken,
    placeholderData
  );
  const { data: amplitudeFlags } = useAmplitudeFlags();

  const isFeatureFlagEnabled =
    amplitudeFlags[FEATURE_FLAGS.activityFeedEditProfile];

  const headerUserData = isFeatureFlagEnabled
    ? getHeaderUserData(RIVTProfile)
    : legacyGetHeaderUserData(RIVTProfile);

  const footerUserData = isFeatureFlagEnabled
    ? getFooterUserData(RIVTProfile)
    : legacyGetFooterUserData(RIVTProfile);

  return { isFetching, headerUserData, footerUserData };
};
